import LockCircle from './LockCircle';

export default LockCircle;
